import { useEffect, useState } from 'react';
import api from '../../api';

const useGetMarketOperatorsPriceAreas = marketOperatorName => {
    const [isReady, setIsReady] = useState(false);
    const [data, setData] = useState([]);

    useEffect(() => {
        if (!marketOperatorName) {
            setData([]);
            setIsReady(false);
            return;
        }

        setIsReady(false);
        setData([]);

        const getAllMarketOperatorsPriceAreas = async () => {
            try {
                const response = await api.get_market_operator_price_areas(marketOperatorName);
                setData(response.data ?? response);
            } catch (error) {
                console.error('Error happened while loading market operators. ', error);
            } finally {
                setIsReady(true);
            }
        };

        getAllMarketOperatorsPriceAreas();
    }, [marketOperatorName]);

    return { isReady, data };
};

export default useGetMarketOperatorsPriceAreas;
